import { useFormsContext } from 'pages/forms/context/FormsProvider';
import React, { useMemo } from 'react';

interface IProps {
  rowIndex: number;
}

export const RenderStatus = ({ rowIndex }: IProps) => {
  const { data } = useFormsContext();

  const statusLabel = useMemo(() => {
    const rowData = data[rowIndex];
    if (rowData?.inCanceled == 'S') return 'Cancelado';
    if (rowData?.inDraft == 'S') return 'Rascunho';
    if (rowData?.inPublished == 'S') return 'Publicado';
    if (rowData?.inInactive == 'S') return 'Inativo';
    return '-';
  }, [data]);

  return <p>{statusLabel}</p>;
};
